export const autoFocus = {
  mounted: el => el.focus(),
};
